import { get, flow, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';
import optionValuesToLabels from '../../../../../helpers/optionValuesToLabels';

export const getAdjustItemForm = get('inventory.components.adjustItemForm');

export const getLocationOptions = createSelector(
  getAdjustItemForm,
  flow(
    get('locationOptions'),
    orderBy('label', 'asc')
  )
);

export const locationOptionValuesToLabels = createSelector(
  (_, values) => values,
  getLocationOptions,
  optionValuesToLabels
);

export const getLocationZoneOptions = createSelector(
  getAdjustItemForm,
  flow(
    get('locationZoneOptions'),
    orderBy('label', 'asc')
  )
);

export const getDonorOptions = createSelector(
  getAdjustItemForm,
  flow(
    get('donorOptions'),
    orderBy('label', 'asc')
  )
);

export const getIsFetchingLocationOptions = flow(
  getAdjustItemForm,
  get('fetchingLocationOptions')
);

export const getIsFetchedLocationOptions = flow(
  getAdjustItemForm,
  get('fetchedLocationOptions')
);

export const getIsFetchingLocationZoneOptions = flow(
  getAdjustItemForm,
  get('fetchingLocationZoneOptions')
);

export const getIsFetchedLocationZoneOptions = flow(
  getAdjustItemForm,
  get('fetchedLocationZoneOptions')
);

export const getIsFetchingDonorOptions = flow(
  getAdjustItemForm,
  get('fetchingDonorOptions')
);

export const getIsFetchedDonorOptions = flow(
  getAdjustItemForm,
  get('fetchedDonorOptions')
);

export const getIsSaving = flow(
  getAdjustItemForm,
  get('saving')
);
export const getIsSaved = flow(
  getAdjustItemForm,
  get('saved')
);
export const getSavingError = flow(
  getAdjustItemForm,
  get('savingError')
);
